import styled from 'styled-components';

interface AlarmModalProps {
    modalText: string;
    onClose: () => void;
}

const AlarmModal = ({ modalText, onClose }: AlarmModalProps) => {
    return (
        <Wrap>
            <Modal className='abs xy-middle'>
                <p>{modalText}</p>
                <button type='button' className='flex aic jcc' onClick={onClose}>확인</button>
            </Modal>
        </Wrap>
    );
}

export default AlarmModal;

const Wrap = styled.div`
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 5;
`
const Modal = styled.div`
    width: 360px;
    box-sizing: border-box;
    padding: 32px 32px 20px 32px;
    background-color: #fff;
    border-radius: 12px;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.16);
    @media (max-width: 767px) {
        width: 100%;
        max-width: 320px;
        padding: 20px 20px 12px 20px;
    }

    > p {
        font-size: 15px;
        line-height: 140%;
        @media (max-width: 767px) {
            font-size: 13px;
        }
    }

    > button {
        width: 56px;
        height: 32px;
        border-radius: 6px;
        background-color: ${props => props.theme.mainColor1};
        font-size: 13px;
        color: #fff;
        margin: 60px auto 0 auto;
        @media (max-width: 767px) {
            width: 52px;
            height: 28px;
            font-size: 11px;
            margin: 52px auto 0 auto;
        }
    }
`